import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { selectAllCarImagesFolders, selectProviderCarsByBusinessLine } from 'src/app/common/store/state/app.state';
import { Car } from 'src/app/public/car/models/car.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { BookingStatus } from 'src/app/public/rent/constants/rent-basic-data';

@Component({
    selector: 'app-admin-rent',
    templateUrl: './admin-rent.component.html',
    styleUrl: './admin-rent.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminRentComponent implements OnInit {

  BookingStatus = BookingStatus;
  
  myRentCars$: Observable<Car[]>;
  myRentCars: Car[] = [];

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;
  
  businessLine: CarBusinessLine = CarBusinessLine.RENT;
  objectSource: ObjectSource = ObjectSource.RENT

  constructor(
    private store: Store, 
    private router: Router
    ) {
      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);
      this.myRentCars$ = store.select(selectProviderCarsByBusinessLine(this.businessLine));
    }

    ngOnInit() {

        this.myRentCars$.subscribe(
          (res: Car[]) =>  {
            this.myRentCars = res!.map(c => Object.assign(new Car(), c));
          }
        );

      this.store.dispatch(DealerActions.fetchAdminCarBasketSubmit({businessLine: this.businessLine}));
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }
}

